<template>
  <el-dialog :close-on-click-modal="false"  
    title="复制订单"
    :visible.sync="visible"
    width="850px"
    top="5vh"
    class="copyOrder"
    :before-close="handleClose"
    
  >
    <div class="order-info-box">
      <div class="fl">
        <b>订单号： </b>
        <el-input v-model="appNo" class="input" size="small" />
      </div>
      <div class="fl">
        <b><span style="color:red;margin: 0 4px 0 0;">*</span>归属渠道： </b>
        <el-select
          v-model="orderData.order.platNo"
          placeholder="请选择平台渠道"
          class="input"
          size="small"
          @change="handleChangePlatNo"
          clearable
        >
          <el-option
            v-for="(value, index) in dictData['plat_no']"
            :key="index"
            :label="value.label"
            :value="value.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="fl">
        <b><span style="color:red;margin: 0 4px 0 0;">*</span>归属店铺： </b>
        <el-select
          v-model="orderData.order.shopId"
          placeholder="请选择店铺名称"
          class="input"
          size="small"
          clearable
        >
          <el-option
            v-for="(item, index) in shopList"
            :key="index"
            :label="item.shopName"
            :value="item.shopId"
            >{{ item.shopName
            }}<span v-if="item.amazonSite"
              >({{ dictMap["amazon_site"][item.amazonSite] }})</span
            >
          </el-option>
        </el-select>
      </div>
    </div>
    <br />
    <div v-show="!nextStep" style="max-height: 62vh;overflow: auto;">
      <div class="t-title">选择产品</div>
      <div v-if="orderData.order && orderData.order.skuList">
        <el-table
          ref="productTable"
          :data="orderData.order.skuList"
          class="exchange-table"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="80"
            align="center"
          ></el-table-column>
          <el-table-column label="产品信息" align="center">
            <template slot-scope="scope">
              <div class="table-info">
                <div class="left">
                  <img class="mini-img" :src="scope.row.picUrl" />
                </div>
                <div class="right">
                  <div class="title">{{ scope.row.proName }}</div>
                  <div
                    class="list"
                    v-for="(i, ind) in [0, 1]"
                    :key="'i_' + ind"
                  >
                    <div class="name">{{ "颜色:尺码".split(":")[i] }}:</div>
                    <div v-if="scope.row.properVal" class="value">
                      <el-select
                        clearable
                        v-model="scope.row.properVal.split(':')[i]"
                        class="input"
                        size="small"
                        @change="
                          (value) => {
                            changeProper(value, i, scope.row)
                          }
                        "
                      >
                        <el-option
                          v-for="(value, index) in attribute[scope.$index][
                            '颜色:尺码'.split(':')[i]
                          ]"
                          :key="index"
                          :label="value"
                          :value="value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="数量" width="120" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.num"
                class="input"
                size="small"
                style="width: 80px;"
                maxlength="5"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div v-show="nextStep">
      <div class="t-title">收货信息</div>
      <div class="order-info-box bd">
        <div class="fl w50">
          <div class="name">
            <b><span style="color:red;margin: 0 4px 0 0;">*</span></b
            >收货人：
          </div>
          <div class="value">
            <el-input
              v-model="orderData.addr.receName"
              class="input"
              size="small"
            />
          </div>
        </div>
        <div class="fl w50">
          <div class="name">
            <b><span style="color:red;margin: 0 4px 0 0;">*</span></b
            >国家：
          </div>
          <div class="value">
            <el-select
              clearable
              v-model="orderData.addr.state"
              placeholder="请选择国家"
              class="input"
              size="small"
              @change="handleChangeState"
            >
              <el-option
                v-for="(value, index) in dictData['amazon_site']"
                :key="index"
                :label="value.label"
                :value="value.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="fl w50">
          <div class="name">
            <b v-if="orderData.addr.state == 'CN'"
              ><span style="color:red;margin: 0 4px 0 0;">*</span></b
            >省州：
          </div>
          <div class="value">
            <el-select
              v-if="orderData.addr.state == 'CN'"
              clearable
              value-key="code"
              size="small"
              v-model="orderData.addr.province"
              placeholder="省"
              @change="provinceChange"
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.code"
                :label="item.name"
                :value="item"
              >
              </el-option>
            </el-select>
            <el-input
              v-else
              v-model="orderData.addr.province"
              class="input"
              size="small"
            />
          </div>
        </div>

        <div class="fl w50">
          <div class="name">
            <b v-if="orderData.addr.state == 'CN'"
              ><span style="color:red;margin: 0 4px 0 0;">*</span></b
            >城市：
          </div>
          <div class="value">
            <el-select
              v-if="orderData.addr.state == 'CN'"
              clearable
              value-key="code"
              size="small"
              v-model="orderData.addr.city"
              placeholder="市"
              @change="cityChange"
            >
              <el-option
                v-for="item in cityOptions"
                :key="item.code"
                :label="item.name"
                :value="item"
              >
              </el-option>
            </el-select>
            <el-input
              v-else
              v-model="orderData.addr.city"
              class="input"
              size="small"
            />
          </div>
        </div>
        <div class="fl w50">
          <div class="name">
            <b v-if="orderData.addr.state == 'CN'"
              ><span style="color:red;margin: 0 4px 0 0;">*</span></b
            >县市：
          </div>
          <div class="value">
            <el-select
              v-if="orderData.addr.state == 'CN'"
              clearable
              value-key="code"
              size="small"
              v-model="orderData.addr.county"
              placeholder="县市"
            >
              <el-option
                v-for="item in areaOptions"
                :key="item.code"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
            <el-input
              v-else
              v-model="orderData.addr.county"
              class="input"
              size="small"
            />
          </div>
        </div>
        <div class="fl w50">
          <div class="name">
            <b><span style="color:red;margin: 0 4px 0 0;">*</span></b
            >地址：
          </div>
          <div class="value">
            <el-input
              v-model="orderData.addr.detailAddr"
              class="input"
              size="small"
            />
          </div>
        </div>
        <div class="fl w50">
          <div class="name">
            <b><span style="color:red;margin: 0 4px 0 0;">*</span></b
            >邮编：
          </div>
          <div class="value">
            <el-input
              v-model="orderData.addr.zipCode"
              class="input"
              size="small"
            />
          </div>
        </div>
        <div class="fl w50">
          <div class="name">
            <b><span style="color:red;margin: 0 4px 0 0;">*</span></b
            >联系方式：
          </div>
          <div class="value">
            <el-input
              v-model="orderData.addr.mobile"
              class="input"
              size="small"
            />
          </div>
        </div>
        <div class="fl w50">
          <div class="name">
            <b><span style="color: red; margin: 0px 4px 0px 0px;"></span></b>
          </div>
          <div class="value">
            <div class="input el-input el-input--small"></div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">取消</el-button>
      <el-button type="primary" @click="next" size="small" v-if="!nextStep">
        下一步
      </el-button>
      <el-button
        type="primary"
        @click="nextStep = false"
        size="small"
        v-if="nextStep"
      >
        上一步
      </el-button>
      <el-button type="primary" @click="sure" size="small" v-if="nextStep">
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopList } from "@/api/system/shopManage"
import { mapGetters } from "vuex"
import { orderCopy } from "@/api/order/all"

export default {
  name: "CopyOrder",
  data() {
    return {
      shopList: [],
      nextStep: false,
      deliver: {},
      multipleSelection: [],
      attribute: [],
      appNo: "",
      provinceOptions: [], // 省份列表
      cityOptions: [],
      areaOptions: [],
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    orderData: {
      type: Object,
      default() {
        return {
          addr: {
            skuList: [],
          },
          expre: {},
          order: {},
          sku: [],
        }
      },
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  mounted() {
    getShopList().then((res) => {
      this.shopList = res.rows
    })
  },
  watch: {
    orderData: {
      handler(val) {
        val.order.skuList.map((el) => {
          if (val.sku) {
            this.attribute.push(JSON.parse(val.sku[el.skuId].attribute))
          }
        })
        this.$nextTick(() => {
          this.$refs.productTable.toggleAllSelection()
        })
        this.loadProvData()
      },
      immediate: true
    },
  },
  methods: {
    // 列表选择
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleChangePlatNo() {
      this.orderData.order.shopId = ""
      getShopList({ platNo: this.orderData.order.platNo }).then((res) => {
        this.shopList = res.rows
      })
    },
    changeProper(data, index, item) {
      let skuId = ""
      let pId = ""
      let picUrl = ""
      const properVal0 = item.properVal.split(":")[0]
      const properVal1 = item.properVal.split(":")[1]
      let newProperVal = ""

      if (index === 0) {
        newProperVal = data + ":" + properVal1
      }

      if (index === 1) {
        newProperVal = properVal0 + ":" + data
      }

      Object.keys(this.orderData.sku).map((el) => {
        if (this.orderData.sku[el].pId === item.pId) {
          this.orderData.sku[el].skuList.map((e) => {
            if (e.properVal.replace(/\\/g, "") === newProperVal) {
              skuId = e.proSkuId ? e.proSkuId : e.skuId
              pId = e.pId

              picUrl = e.mainPic.picUrl
            }
          })
        }
      })

      item.properVal = newProperVal
      item.skuId = skuId
      item.pId = pId
      item.picUrl = picUrl
    },
    next() {
      if (this.orderData.order.channel == "") {
        this.$message({
          message: "请填写归属渠道",
          type: "error",
        })
        return
      }
      if (this.orderData.order.shopId == "") {
        this.$message({
          message: "请填写归属店铺",
          type: "error",
        })
        return
      }
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: "请选择一个产品",
          type: "error",
        })
        return
      }
      this.nextStep = true
    },
    // 获取省市区数据
    loadProvData() {
      $.ajax({
        url: process.env.BASE_URL + "areaData.json",
        method: "get",
        success: (res) => {
          console.log(this.orderData)
          this.provinceOptions = res["regionalDivision"]
          this.provinceChange({ name: this.orderData.addr.province })
        },
      })
    },
    provinceChange(val) {
      this.cityOptions = []
      this.provinceOptions.forEach((item) => {
        if (item.name == val.name) {
          console.log(this.cityOptions)
          this.cityOptions = item.city
        }
      })
      this.orderData.addr.province = val.name
      //清空值
      // this.orderData.addr.city = undefined
      // this.newAddr.county = undefined
      //不为空时,市和县默认赋值第一个
      if (this.cityOptions.length > 0) {
        this.orderData.addr.city = this.cityOptions[0].name
        this.cityChange(this.cityOptions[0])
      }
    },
    // 城市下拉修改
    cityChange(val) {
      this.areaOptions = []
      this.cityOptions.forEach((item) => {
        if (item.code == val.code) {
          this.areaOptions = item.district
          return
        }
      })
      this.orderData.addr.city = val.name

      if (this.areaOptions.length > 0) {
        this.orderData.addr.county = this.areaOptions[0].name
      }
    },
    sure() {
      let params = Object.assign({}, this.orderData)
      params.order.appNo = this.appNo
      const idList = []
      const newSkuList = []
      //验证信息是否填写
      if (!this.orderData.addr.receName || this.orderData.addr.receName == "") {
        this.$message({
          message: "请填写收货人",
          type: "error",
        })
        return
      }
      if (!this.orderData.addr.state || this.orderData.addr.state == "") {
        this.$message({
          message: "请填写国家",
          type: "error",
        })
        return
      }
      if (
        this.orderData.addr.state == "CN" &&
        (!this.orderData.addr.province || this.orderData.addr.province == "")
      ) {
        this.$message({
          message: "请填写省州",
          type: "error",
        })
        return
      }
      if (!this.orderData.addr.zipCode || this.orderData.addr.zipCode == "") {
        this.$message({
          message: "请填写邮编",
          type: "error",
        })
        return
      }
      if (
        this.orderData.addr.state == "CN" &&
        (!this.orderData.addr.city || this.orderData.addr.city == "")
      ) {
        this.$message({
          message: "请填写城市",
          type: "error",
        })
        return
      }
      if (
        !this.orderData.addr.detailAddr ||
        this.orderData.addr.detailAddr == ""
      ) {
        this.$message({
          message: "请填写地址",
          type: "error",
        })
        return
      }
      if (!this.orderData.addr.mobile || this.orderData.addr.mobile == "") {
        this.$message({
          message: "请填写联系方式",
          type: "error",
        })
        return
      }

      this.multipleSelection.map((el) => {
        idList.push(el.skuId)
      })

      params.order.skuList.map((el) => {
        if (idList.includes(el.skuId)) {
          newSkuList.push(el)
        }
      })

      delete params.sku

      params.order.skuList = newSkuList

      orderCopy(params).then((res) => {
        if (res.code !== 200) {
          this.$message.error("复制失败")
        } else {
          this.$message.success("复制成功")
          this.nextStep = false
          this.$emit("onOk")
        }
      })
    },
    handleClose() {
      this.nextStep = false
      this.$emit("onClose")
    },
    handleChangeState(){
      this.orderData.addr.city = undefined
      this.orderData.addr.province = undefined
      this.orderData.addr.county = undefined
    }
  },
}
</script>

<style scoped lang="scss">
.w50 {
  width: 50%;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  align-items: center;

  .name {
    width: 109px;
  }

  .value {
    width: 260px;
  }
}

.bd {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ebeef5;
}

.copyOrder {
  font-size: 12px;
}

.order-info-box {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .fl {
    display: flex;
    align-items: center;
    width: 32%;

    b {
      width: 100px;
    }
  }
}

.t-title {
  background: #f5f7fa;
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  font-weight: bold;
  border: 1px solid #ebeef5;
  border-bottom: 0;
}

.table-info {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 0 10px;
  font-size: 12px;

  &:last-child {
    margin-bottom: 0;
    border-bottom: 0;
  }

  .left {
    margin-right: 20px;
    width: 90px;
    height: 90px;
    border: 1px solid #ebeef5;

    .mini-img {
      width: 100%;
      height: 100%;
    }
  }

  .right {
    display: flex;
    flex-direction: column;

    .title {
      text-align: left;
      padding-left: 15px;
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: bold;
    }

    .list {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      width: 212px;

      .name {
        width: 85px;
      }

      .value {
        width: 100%;
      }
    }
  }
}
</style>
